import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/main.css'
import HelpTip from './components/HelpTip.vue'
import { vTooltip } from './directives/tooltip'

const app = createApp(App)

app.use(store)
app.use(router)

app.component('HelpTip', HelpTip)
app.directive('tooltip', vTooltip)

app.mount('#app')
